import { render, staticRenderFns } from "./TocItem.vue?vue&type=template&id=0b867852&scoped=true&"
import script from "./TocItem.vue?vue&type=script&lang=js&"
export * from "./TocItem.vue?vue&type=script&lang=js&"
import style0 from "./TocItem.vue?vue&type=style&index=0&id=0b867852&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b867852",
  null
  
)

export default component.exports